export const AUDIENCE_TARGET_LIMIT = 10;

interface AudienceTargeting {
  targetType: AudienceTarget;
  targetEvaluation?: TargetEvaluation;
  value?: string;
}

export const AUDIENCE_TARGET_TYPE = {
  DEFAULT: 'DEFAULT',
  REFERRER_SOURCE: 'REFERRER_SOURCE',
  UTM: 'UTM',
} as const;
export type AudienceTarget = (typeof AUDIENCE_TARGET_TYPE)[keyof typeof AUDIENCE_TARGET_TYPE];

const TARGET_TYPE_TITLE = {
  [AUDIENCE_TARGET_TYPE.DEFAULT]: 'Everyone coming to the website',
  [AUDIENCE_TARGET_TYPE.REFERRER_SOURCE]: 'Referrer source',
  [AUDIENCE_TARGET_TYPE.UTM]: 'UTM',
};

export const getAudienceTargetLabel = (value: AudienceTarget) => TARGET_TYPE_TITLE[value];

export const TARGET_EVALUATION = {
  IS_EXACTLY: 'EXACT_MATCH',
  CONTAINS: 'CONTAINS',
} as const;
export type TargetEvaluation = (typeof TARGET_EVALUATION)[keyof typeof TARGET_EVALUATION];

const TARGET_EVALUATION_TITLE = {
  [TARGET_EVALUATION.IS_EXACTLY]: 'is exactly: ',
  [TARGET_EVALUATION.CONTAINS]: 'contains: ',
};

export const getAudienceTargetEvaluationLabel = (value: TargetEvaluation) =>
  TARGET_EVALUATION_TITLE[value];

export const getAudienceTargetTitle = (targeting: AudienceTargeting) => {
  const evaluationLabel = targeting.targetEvaluation
    ? getAudienceTargetEvaluationLabel(targeting.targetEvaluation)
    : '';
  return `${TARGET_TYPE_TITLE[targeting.targetType]} ${evaluationLabel || ''}`;
};

export const getAudiencesTargetingDescription = (targeting: AudienceTargeting) => {
  if (
    targeting.targetType === AUDIENCE_TARGET_TYPE.DEFAULT ||
    !targeting.targetEvaluation ||
    !targeting.value
  ) {
    return '';
  }

  return targeting.value;
};

export const getAudiencesTargetingTitle = (targeting: AudienceTargeting) => {
  const typeLabel = getAudienceTargetLabel(targeting.targetType);
  const description = getAudiencesTargetingDescription(targeting);
  if (!description) {
    return typeLabel;
  }

  return `${typeLabel} ${description}`;
};

export const isDefaultAudienceTarget = (targeting: AudienceTargeting) =>
  targeting.targetType === AUDIENCE_TARGET_TYPE.DEFAULT;

export const withoutDefaultAudienceTarget = (targets: AudienceTargeting[]) =>
  targets.filter((segment) => !isDefaultAudienceTarget(segment));
